import type { CreateActionOnDeploymentRequestByIdV2MutationRequestApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { CancelDeploymentBody } from '../../../models/deployment/cancelDeployment.model';

export function mapCancelDeploymentBody(
  body: CancelDeploymentBody,
): CreateActionOnDeploymentRequestByIdV2MutationRequestApi {
  return {
    ...body,
  };
}
